module.exports = __webpack_public_path__ + "img/img_patrol.23c13017.jpg";